"use strict";
/********************************************************************************
  HxCollectionChange.ts
  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxCollectionChange = exports.HxCollectionChangeType = void 0;
var HxCollectionChangeType;
(function (HxCollectionChangeType) {
    HxCollectionChangeType[HxCollectionChangeType["ItemCreated"] = 1] = "ItemCreated";
    HxCollectionChangeType[HxCollectionChangeType["ItemChanged"] = 0] = "ItemChanged";
    HxCollectionChangeType[HxCollectionChangeType["ItemRemoved"] = -1] = "ItemRemoved";
})(HxCollectionChangeType = exports.HxCollectionChangeType || (exports.HxCollectionChangeType = {}));
var HxCollectionChange = /** @class */ (function () {
    function HxCollectionChange(type, index, objectId, object) {
        this.type = type;
        this.index = index;
        this.objectId = objectId;
        this.object = object;
    }
    return HxCollectionChange;
}());
exports.HxCollectionChange = HxCollectionChange;
